<mat-toolbar class="sidemenu-toolbar">
    <i class="icon mdi mdi-database"></i>
    <span class="title">Entity</span>
</mat-toolbar>

<mat-accordion class="mat-list-custom" togglePosition="before" displayMode="flat" *ngIf="entityList.length > 0">
    <ng-container *ngFor="let entity of entityList; let index = index">
        <mat-expansion-panel [expanded]="entity.open" (opened)="toggleEntity(true, entity.entity_id,eventTypes.click)" (closed)="toggleEntity(false, entity.entity_id,eventTypes.closed)">
            <mat-expansion-panel-header [class.active]="entity.open" class="mat-list-item" mat-ripple
                (click)="onEntityClicked(entity, index)">
                <mat-panel-title class="item-fill w-75 me-0">
                    <span class="text-ellipsis">{{ entity.entity_name | titlecase }}</span>
                </mat-panel-title>
                <div class="item-end control-buttons">
                    <button mat-icon-button (click)="$event.stopPropagation();editEntityName(addEntityPopUp, entity.entity_id, entity.entity_name)" *ngIf="[appPermissions.editEntity,permissionsActions.edit] | builderPermissions"><mat-icon>edit</mat-icon></button>
                    <button mat-icon-button color="warn"  (click)="$event.stopPropagation();deleteEntityPopup(deleteEntityPopUp,entity,index)" *ngIf="[appPermissions.deleteEntity,permissionsActions.edit]| builderPermissions"><mat-icon>delete</mat-icon></button>
                </div>
            </mat-expansion-panel-header>
           
            <mat-accordion class="mat-list-custom mx-1" togglePosition="before" displayMode="flat" [multi]="false" >
                <!-- Mapped Pages -->
                <mat-expansion-panel [expanded]="matPanelStatus" (opened)="matPanelStatus = true; showselectPageError=false;"
                    (closed)="matPanelStatus = false">
                    <mat-expansion-panel-header [class.active]="matPanelStatus" class="mat-list-item" mat-ripple>
                        <mat-panel-title class="item-fill">
                            <span>Mapped Pages</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="genarating-app"  *ngIf="isLoadingMappedEntities">
                      <mat-spinner diameter="25"></mat-spinner>
                    </div>
                    <ng-container *ngIf="entityPages.length > 0 && !isLoadingMappedEntities">
                        <mat-list *ngFor="let page of entityPages; let index = index">
                            <mat-list-item>
                                <span class="d-flex align-items-center justify-content-between gap-3">
                                    <span [matTooltip]="page.pageName.length > 25 ? page.pageName : ''">{{ page.pageName | titlecase | truncate : 25}}</span>
                                    <div class="item-end control-buttons">
                                        @if([appPermissions.editEntity,permissionsActions.edit] | builderPermissions){
                                            <button mat-icon-button color="warn" class="mat-small"
                                                (click)="removePageFromEntity(page.pageId, index)"><mat-icon>delete</mat-icon></button>
                                        }
                                    </div>
                                </span>
                            </mat-list-item>
                        </mat-list>
                    </ng-container>
            
                    @if([appPermissions.editEntity,permissionsActions.edit] | builderPermissions){
                    <mat-form-field *ngIf="isAddAttributes && pageListDropdown.length !=0" appearance="outline" class="mt-2 w-100"
                        [formGroup]="entityForm">
                        <mat-label>Page</mat-label>
                        <mat-select matNativeControl formControlName="attributes" placeholder="Select Page">
                            <ng-container *ngFor="let item of pageListDropdown">
                                <mat-option [value]="item.pageId">{{ item.pageName }}</mat-option>
                            </ng-container>
                        </mat-select>
                        <mat-hint *ngIf="matPanelStatus && showselectPageError" class="text-danger "> Please select a
                            page</mat-hint>
                    </mat-form-field>
                        <button mat-stroked-button color="primary" class="add-button w-100 mt-4" (click)="addPage()"
                            [disabled]="pageListDropdown.length == 0">
                            <mat-icon>add</mat-icon>
                            Add Page
                        </button>
                    }
                </mat-expansion-panel>
            
                <!-- Related Entities -->
                <mat-expansion-panel [expanded]="relatedPanelStatus" (opened)="togglePanelRelatedEntity(true)"
                    (closed)="togglePanelRelatedEntity(false)">
                    <mat-expansion-panel-header [class.active]="relatedPanelStatus" class="mat-list-item" mat-ripple>
                        <mat-panel-title class="item-fill">
                            <span>Related Entities</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngIf="relativeEntity.length > 0">
                        <mat-list *ngFor="let entity of relativeEntity; let index = index">
                            <mat-list-item>
                                <span class="d-flex align-items-center justify-content-between gap-3">
                                    <span>{{ entity.entity_name | titlecase }}</span>
                                    <div class="item-end control-buttons">
                                        @if([appPermissions.editEntity,permissionsActions.edit] | builderPermissions){
                                            <button mat-icon-button color="warn" class="mat-small"
                                                (click)="removeRelativeEntityFromEntity(entity.entity_id, index)"><mat-icon>delete</mat-icon></button>
                                        }
                                    </div>
                                </span>
                            </mat-list-item>
                        </mat-list>
                    </ng-container>
                    @if([appPermissions.editEntity,permissionsActions.edit] | builderPermissions){

                    <ng-container [formGroup]="entityForm">
                        <mat-form-field *ngIf="isAddRelations" appearance="outline" class="mt-2 w-100">
                            <mat-label>Related Entity</mat-label>
                            <mat-select matNativeControl formControlName="child" placeholder="Select Entity" (focus)="isSelectFocused = true" (blur)="isSelectFocused = false">
                                <ng-container *ngFor="let item of relatedEntityList">
                                    <mat-option
                                        *ngIf="selectedEntityName?.trim()?.toLowerCase() != item.entity_name?.trim()?.toLowerCase()"
                                        [value]="item.entity_id">{{ item.entity_name}}</mat-option>
                                </ng-container>
                            </mat-select>
                    </mat-form-field>   
                    <mat-error *ngIf="isSelectFocused && relatedEntityList.length == 1">
                        No related entities
                    </mat-error>

                        <ng-container *ngIf="showRelativeField && entityForm.get('child')?.value" formGroupName="childField">
                            <mat-form-field class="mt-1 w-100">
                                <mat-label>Parent Entity Field</mat-label>
                                <mat-select matNativeControl formControlName="parent" placeholder="Select Field"
                                    (focus)="handleParentFieldTouch()">
                                    <ng-container *ngFor="let item of entityFields">
                                        <mat-option [value]="item.widgetId">{{ item.widgetLabel }}</mat-option>
                                    </ng-container>
                                </mat-select>
            
                                <mat-hint
                                    [innerHTML]="!buttonClickedParent ? ((parentFieldClicked && entityFields.length === 0 )? 'No parent fields' : ''): showselectEntityParentError ? 'Please select parent field' : ''"
                                    class="text-danger"></mat-hint>
            
                            </mat-form-field>
            
                            <mat-form-field class="mt-1 w-100">
                                <mat-label>Child Entity Field</mat-label>
                                <mat-select matNativeControl formControlName="child" placeholder="Select Field"
                                    (focus)="handleChildFieldTouch()">
                                    <ng-container *ngFor="let item of selectedEntityFields">
                                        <mat-option [value]="item.widgetId">{{ item.widgetLabel }}</mat-option>
                                    </ng-container>
                                </mat-select>
                                <mat-hint
                                    [innerHTML]="!buttonClickedChild ? ((childFieldClicked && selectedEntityFields.length === 0 )? 'No child fields' : ''): showselectEntityChildError ? 'Please select child field' : ''"
                                    class="text-danger"></mat-hint>
            
            
                            </mat-form-field>
                        </ng-container>
            
                    </ng-container> 
                }
                    @if([appPermissions.editEntity,permissionsActions.edit] | builderPermissions){
                        <button mat-stroked-button color="primary" class="add-button w-100 mt-3" (click)="addRelatedEntities(); "
                            [disabled]="relatedEntityList.length == 1">
                            <mat-icon>add</mat-icon>
                            Add Related Entity
                        </button>
                    }
                </mat-expansion-panel>

                <!-- WorkFlow -->
                <mat-expansion-panel #workflowPanel [expanded]="workflowPanelStatus"*ngIf="entity.open" >
                    <mat-expansion-panel-header [class.active]="workflowPanelStatus" class="mat-list-item" mat-ripple>
                        <mat-panel-title class="item-fill">
                            <span>WorkFlow</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <lib-workflow *ngIf="workflowPanel.expanded" [queryParams]="queryParams"   [entity]="entity"  ></lib-workflow>
                </mat-expansion-panel>
            </mat-accordion>
            @if([appPermissions.editEntity,permissionsActions.edit] | builderPermissions){
                <button mat-stroked-button color="primary" class="add-button w-100 mt-3"
                    (click)="updateEntity(entity.entity_id)">
                    Update Association
                </button> 
            }

        </mat-expansion-panel>
    </ng-container>
</mat-accordion>
    <div class="p-3">
        <button mat-stroked-button color="primary" class="add-button w-100 " *ngIf="[appPermissions.addEntity,permissionsActions.edit] | builderPermissions" (click)="openModal(addEntityPopUp, false)">
            <mat-icon>add</mat-icon>
            Add Entity
        </button>
    </div>
    

<!-- Add or Edit Entity -->
<ng-template #addEntityPopUp>
    <div (keydown.escape)="closeTemplate()" (keydown.enter)="onEnterPressed(popupEntity.entityId)">
        <mat-dialog-content class="add-page-dailog">
            <div class="row">
                <div class="col-12" [formGroup]="entityForm">
                    <h2>
                        <span *ngIf="!isEdit">Add Entity</span>
                        <span *ngIf="isEdit">Edit Entity</span>
                    </h2>
                    <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Entity Name</mat-label>
                        <input matInput placeholder="Entity Name" formControlName="name" (input)="onEntityNameAdd($event)" />
                        <mat-hint class="error-message" *ngIf="!isEntityNameUnique">Entity name already exist</mat-hint>
                    </mat-form-field>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions class="dailog-footer-buttons">
            <button mat-button (click)="closeTemplate()">Cancel</button>
            <button mat-raised-button color="primary" [disabled]="entityForm.invalid || !isEntityNameUnique"
                (click)="saveEntiy(popupEntity.entityId)">Save</button>
        </mat-dialog-actions>
    </div>
</ng-template>

<ng-template #deleteEntityPopUp>
    <div (keydown.escape)="closeTemplate()" (keydown.enter)="deleteEntity(deleteEntityid)">
        <mat-dialog-content class="add-page-dailog">
            <div class="row">
                <div class="col-12 ">
                    <h2 class="header-with-underline">
                        <span>Delete Entity</span>
                    </h2>
                </div>
                <div class="col-12 text-center " *ngIf="pageNamesList.length > 0">
                    <span>Before deleting the <b>{{entityName | titlecase}}</b> entity, please note that it will permanently remove the association
                        with <b>{{pageNamesList.join(', ') | titlecase}}</b> and their associated data. Additionally, any references to this page's data
                         may be lost. Please proceed with caution</span>
                </div>
                <div class="col-12  text-center mt-1">
                    <mat-icon class="delete-icon">warning</mat-icon>
                </div>
                <div class="col-12 text-center">
                    <h6 class="text-danger" style="font-size: medium;">Are you sure to delete?</h6>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions class="dailog-footer-buttons">
            <button mat-button (click)="closeTemplate()">Cancel</button>
            <button mat-raised-button color="primary" (click)="deleteEntity(deleteEntityid)">Yes</button>
        </mat-dialog-actions>
    </div>
</ng-template>

<!-- Add WorkFlow -->
<ng-template #addWorkFlowPopUp>
    <div (keydown.escape)="closeTemplate()">
        <mat-dialog-content class="add-page-dailog">
            <div class="row">
                <div class="col-12" [formGroup]="workFlowForm">
                    <h4>
                        <span *ngIf="!isEdit">Add WorkFlow</span>
                        <span *ngIf="isEdit">Edit WorkFlow</span>
                    </h4>
                    <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Title</mat-label>
                        <input matInput placeholder="WorkFlow Name" formControlName="name" />
                        <mat-hint class="error-message" *ngIf="!isEntityNameUnique">workflow name already exist</mat-hint>
                    </mat-form-field>

                    <mat-label *ngIf="!isEdit">Stages</mat-label><br>
                    <ng-container formArrayName="stages" *ngIf="!isEdit">
                        <ng-container *ngFor="let stage of stageArray.controls; let i = index">
                            <mat-form-field class="w-75" appearance="outline" [formGroupName]="i" [class.mt-3]="i === 0">
                                <mat-label>Stage Title</mat-label>
                                <input matInput placeholder="Stage Name" formControlName="name" />
                                <mat-hint class="error-message" *ngIf="!isEntityNameUnique">Stage name already exist</mat-hint>
                            </mat-form-field>
                            <button mat-icon-button color="warn" class="bg-danger text-white mx-4" *ngIf="i > 1 && i != stageArray.controls.length - 1" (click)="deleteStage(i)"><mat-icon>delete</mat-icon></button>
                            <button mat-icon-button class="text-dark mx-4" *ngIf="i == stageArray.controls.length - 1" (click)="addStage()"><mat-icon>add</mat-icon></button>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions class="dailog-footer-buttons">
            <button mat-raised-button class="rounded-3" (click)="closeTemplate()">Cancel</button>
            <button mat-raised-button color="primary" class="rounded-3" [disabled]="workFlowForm.invalid" (click)="saveWorkFlow(popupEntity.entityId, isEdit)">Save</button>
        </mat-dialog-actions>
    </div>
</ng-template>

<ng-template #deleteWorkFlowPopUp>
    <div (keydown.escape)="closeTemplate()" (keydown.enter)="deleteWorkFlow(workFlowDeleteEntity.deleteId, workFlowDeleteEntity.entityId)">
        <mat-dialog-content class="add-page-dailog">
            <div class="row">
                <div class="col-12 ">
                    <h2 class="header-with-underline">
                        <span>Delete WorkFlow</span>
                    </h2>
                </div>
                <div class="col-12 text-center ">
                    <span>Before deleting the <b>{{workFlowDeleteEntity.deleteName| titlecase}}</b> workflow, please note that it will permanently remove the 
                        workflow, stages and their associated configuarations. Additionally, any references to this workflow data may be lost. Please proceed with caution</span>
                </div>
                <div class="col-12  text-center mt-1">
                    <mat-icon class="delete-icon">warning</mat-icon>
                </div>
                <div class="col-12 text-center">
                    <h6 class="text-danger" style="font-size: medium;">Are you sure to delete?</h6>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions class="dailog-footer-buttons">
            <button mat-button (click)="closeTemplate()">Cancel</button>
            <button mat-raised-button color="primary" (click)="deleteWorkFlow(workFlowDeleteEntity.deleteId, workFlowDeleteEntity.entityId)">Yes</button>
        </mat-dialog-actions>
    </div>
</ng-template>

<ng-template #deleteStagePopUp>
    <div (keydown.escape)="closeTemplate()" (keydown.enter)="deleteStageFromWorkFlow(workFlowDeleteEntity.deleteId)">
        <mat-dialog-content class="add-page-dailog">
            <div class="row">
                <div class="col-12 ">
                    <h2 class="header-with-underline">
                        <span>Delete WorkFlow</span>
                    </h2>
                </div>
                <div class="col-12 text-center ">
                    <span>Before deleting the <b>{{workFlowDeleteEntity.deleteName| titlecase}}</b> stage, please note that it will permanently remove the
                        stage and their associated configuarations. Additionally, any references to this workflow data may be lost. Please proceed with caution</span>
                </div>
                <div class="col-12  text-center mt-1">
                    <mat-icon class="delete-icon">warning</mat-icon>
                </div>
                <div class="col-12 text-center">
                    <h6 class="text-danger" style="font-size: medium;">Are you sure to delete?</h6>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions class="dailog-footer-buttons">
            <button mat-button (click)="closeTemplate()">No</button>
            <button mat-raised-button color="primary" (click)="deleteStageFromWorkFlow(workFlowDeleteEntity.deleteId)">Yes</button>
        </mat-dialog-actions>
    </div>
</ng-template>